/*
 * AI1 WORLD - Prestige Wishlist (cart / drawer module)
 * Adds a slide-in wishlist drawer (opened from the header heart icon), a
 * variant selector per saved item, per-item "Add to cart" and "Move all to
 * cart", routing everything into the existing Prestige cart drawer.
 * Depends on window.AI1WL (ai1-wishlist.js), loaded first.
 */
(function () {
  'use strict';
  var A = window.AI1WL;
  if (!A) return;

  var productCache = {};
  function root() { return A.root(); }
  function esc(s) { return A.esc(s); }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch(root() + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }
  function openCart() {
    if (typeof window.ai1OpenCart === 'function') { window.ai1OpenCart(); return; }
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') { cd.open(); return; }
    window.location.href = root() + 'cart';
  }
  function addVariantToCart(variantId, qty) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }

  /* drawer */
  function buildDrawer() {
    if (document.getElementById('ai1-wl-drawer')) return;
    var d = document.createElement('div');
    d.className = 'ai1-wl-drawer';
    d.id = 'ai1-wl-drawer';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<div class="ai1-wl-drawer__overlay" data-wl-close></div>' +
      '<aside class="ai1-wl-drawer__panel" role="dialog" aria-modal="true" aria-label="Wishlist">' +
        '<header class="ai1-wl-drawer__head">' +
          '<h2>My Wishlist <span class="ai1-wl-drawer__count">0</span></h2>' +
          '<button type="button" class="ai1-wl-drawer__close" data-wl-close aria-label="Close">&times;</button>' +
        '</header>' +
        '<div class="ai1-wl-drawer__body"></div>' +
        '<footer class="ai1-wl-drawer__foot">' +
          '<button type="button" class="ai1-wl-drawer__addall button">Move all to cart</button>' +
          '<a class="ai1-wl-drawer__viewall" href="' + esc(A.wishlistUrl()) + '">View full wishlist</a>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(d);
    d.addEventListener('click', function (e) { if (e.target.closest('[data-wl-close]')) closeDrawer(); });
    d.querySelector('.ai1-wl-drawer__addall').addEventListener('click', moveAllToCart);
  }
  function openDrawer() {
    buildDrawer();
    var d = document.getElementById('ai1-wl-drawer');
    renderDrawer();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ai1-wl-drawer-open');
    hydrateDrawerVariants();
  }
  function closeDrawer() {
    var d = document.getElementById('ai1-wl-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ai1-wl-drawer-open');
  }
  function renderDrawer() {
    var d = document.getElementById('ai1-wl-drawer');
    if (!d) return;
    var body = d.querySelector('.ai1-wl-drawer__body');
    var foot = d.querySelector('.ai1-wl-drawer__foot');
    var items = A.read();
    A.updateBadge();
    if (!items.length) {
      body.innerHTML = '<div class="ai1-wl-drawer__empty">Your wishlist is empty. Tap the heart on any product to save it here.</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = items.map(function (i) {
      var img = i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '';
      return '<div class="ai1-wl-di" data-handle="' + esc(i.handle) + '">' +
          '<a class="ai1-wl-di__media" href="' + esc(i.url) + '">' + img + '</a>' +
          '<div class="ai1-wl-di__info">' +
            '<a class="ai1-wl-di__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
            '<div class="ai1-wl-di__price">' + esc(i.price || '') + '</div>' +
            '<div class="ai1-wl-di__variant"></div>' +
            '<div class="ai1-wl-di__actions">' +
              '<button type="button" class="ai1-wl-di__add">Add to cart</button>' +
              '<button type="button" class="ai1-wl-di__remove" data-handle="' + esc(i.handle) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');
  }
  function hydrateDrawerVariants() {
    var d = document.getElementById('ai1-wl-drawer');
    if (!d) return;
    Array.prototype.forEach.call(d.querySelectorAll('.ai1-wl-di'), function (row) {
      var handle = row.getAttribute('data-handle');
      var addBtn = row.querySelector('.ai1-wl-di__add');
      fetchProduct(handle).then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var vslot = row.querySelector('.ai1-wl-di__variant');
        if (p.variants.length === 1) {
          addBtn.setAttribute('data-variant-id', p.variants[0].id);
          if (!p.variants[0].available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
        } else {
          var opts = p.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (sold out)') + '</option>';
          }).join('');
          vslot.innerHTML = '<select aria-label="Choose option">' + opts + '</select>';
          var sel = vslot.querySelector('select');
          var firstAvail = p.variants.filter(function (v) { return v.available; })[0];
          if (firstAvail) sel.value = firstAvail.id;
          addBtn.setAttribute('data-variant-id', sel.value);
          sel.addEventListener('change', function () { addBtn.setAttribute('data-variant-id', sel.value); });
        }
      });
    });
  }
  function drawerAdd(row) {
    var addBtn = row.querySelector('.ai1-wl-di__add');
    var handle = row.getAttribute('data-handle');
    var vid = addBtn && addBtn.getAttribute('data-variant-id');
    if (!vid) {
      var item = A.read().filter(function (i) { return i.handle === handle; })[0];
      if (item) window.location.href = item.url;
      return Promise.resolve(false);
    }
    addBtn.disabled = true;
    return addVariantToCart(vid, 1).then(function (r) {
      addBtn.disabled = false;
      if (!r.ok || (r.data && r.data.status)) { A.toast((r.data && r.data.description) || 'Could not add to cart'); return false; }
      return true;
    }).catch(function () { addBtn.disabled = false; A.toast('Could not add to cart'); return false; });
  }
  function moveAllToCart() {
    var d = document.getElementById('ai1-wl-drawer');
    if (!d) return;
    var rows = Array.prototype.slice.call(d.querySelectorAll('.ai1-wl-di'));
    if (!rows.length) return;
    var added = 0, needOptions = 0;
    var chain = Promise.resolve();
    rows.forEach(function (row) {
      var addBtn = row.querySelector('.ai1-wl-di__add');
      var vid = addBtn && addBtn.getAttribute('data-variant-id');
      if (!vid) { needOptions++; return; }
      chain = chain.then(function () {
        return addVariantToCart(vid, 1).then(function (r) {
          if (r.ok && !(r.data && r.data.status)) { added++; A.remove(row.getAttribute('data-handle')); }
        }).catch(function () {});
      });
    });
    chain.then(function () {
      if (added) {
        closeDrawer();
        openCart();
        A.toast(added + (added === 1 ? ' item moved to cart' : ' items moved to cart') + (needOptions ? ' - ' + needOptions + ' still need a size/colour' : ''));
      } else if (needOptions) {
        A.toast('Choose a size/colour for each item first');
      }
    });
  }

  /* wishlist page (SHEIN-style): variant hydration + individual/bulk add-to-bag */
  function hydratePage() {
    var root = document.getElementById('ai1-wishlist-root');
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('.ai1-wl-card'), function (card) {
      var addBtn = card.querySelector('.ai1-wl-card__add');
      if (!addBtn || addBtn.getAttribute('data-hydrated')) return;
      addBtn.setAttribute('data-hydrated', '1');
      var handle = card.getAttribute('data-handle');
      fetchProduct(handle).then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var vslot = card.querySelector('.ai1-wl-card__variant');
        if (p.variants.length === 1) {
          addBtn.setAttribute('data-variant-id', p.variants[0].id);
          if (!p.variants[0].available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
        } else {
          var opts = p.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (sold out)') + '</option>';
          }).join('');
          vslot.innerHTML = '<select aria-label="Choose option">' + opts + '</select>';
          var sel = vslot.querySelector('select');
          var firstAvail = p.variants.filter(function (v) { return v.available; })[0];
          if (firstAvail) sel.value = firstAvail.id;
          addBtn.setAttribute('data-variant-id', sel.value);
          sel.addEventListener('change', function () { addBtn.setAttribute('data-variant-id', sel.value); });
        }
      });
    });
    updateSelState();
  }
  function pageAdd(card) {
    var addBtn = card.querySelector('.ai1-wl-card__add');
    var vid = addBtn && addBtn.getAttribute('data-variant-id');
    if (!vid) {
      var handle = card.getAttribute('data-handle');
      var item = A.read().filter(function (i) { return i.handle === handle; })[0];
      if (item) window.location.href = item.url;
      return Promise.resolve(false);
    }
    addBtn.disabled = true;
    return addVariantToCart(vid, 1).then(function (r) {
      addBtn.disabled = false;
      if (!r.ok || (r.data && r.data.status)) { A.toast((r.data && r.data.description) || 'Could not add to bag'); return false; }
      return true;
    }).catch(function () { addBtn.disabled = false; A.toast('Could not add to bag'); return false; });
  }
  function selectedCards() {
    var root = document.getElementById('ai1-wishlist-root');
    if (!root) return [];
    return Array.prototype.filter.call(root.querySelectorAll('.ai1-wl-card'), function (c) {
      var cb = c.querySelector('.ai1-wl-check');
      return cb && cb.checked;
    });
  }
  function updateSelState() {
    var root = document.getElementById('ai1-wishlist-root');
    if (!root) return;
    var all = root.querySelectorAll('.ai1-wl-card');
    var sel = selectedCards();
    var master = root.querySelector('.ai1-wl-select-all');
    if (master) master.checked = all.length > 0 && sel.length === all.length;
    var btn = root.querySelector('.ai1-wl-addselected');
    if (btn) btn.textContent = sel.length ? ('Add ' + sel.length + ' to bag') : 'Add selected to bag';
  }
  function addSelectedToBag() {
    var cards = selectedCards();
    if (!cards.length) { A.toast('Select items first'); return; }
    var added = 0, need = 0;
    var chain = Promise.resolve();
    cards.forEach(function (card) {
      var addBtn = card.querySelector('.ai1-wl-card__add');
      var vid = addBtn && addBtn.getAttribute('data-variant-id');
      if (!vid) { need++; return; }
      chain = chain.then(function () {
        return addVariantToCart(vid, 1).then(function (r) { if (r.ok && !(r.data && r.data.status)) added++; }).catch(function () {});
      });
    });
    chain.then(function () {
      if (added) { openCart(); A.toast(added + (added === 1 ? ' item added to bag' : ' items added to bag') + (need ? ' - ' + need + ' need a size/colour' : '')); }
      else if (need) { A.toast('Choose a size/colour first'); }
    });
  }

  /* clicks + keyboard */
  document.addEventListener('click', function (e) {
    var addEl = e.target.closest ? e.target.closest('.ai1-wl-di__add') : null;
    if (!addEl) return;
    e.preventDefault();
    drawerAdd(addEl.closest('.ai1-wl-di')).then(function (ok) { if (ok) { openCart(); A.toast('Added to cart'); } });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('click', function (e) {
    var t = e.target;
    var pageAddEl = t.closest ? t.closest('.ai1-wl-card__add') : null;
    if (pageAddEl) {
      e.preventDefault();
      pageAdd(pageAddEl.closest('.ai1-wl-card')).then(function (ok) { if (ok) { openCart(); A.toast('Added to bag'); } });
      return;
    }
    if (t.closest && t.closest('.ai1-wl-addselected')) { e.preventDefault(); addSelectedToBag(); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('ai1-wl-select-all')) {
      var root = document.getElementById('ai1-wishlist-root');
      if (root) Array.prototype.forEach.call(root.querySelectorAll('.ai1-wl-check'), function (cb) { cb.checked = t.checked; });
      updateSelState();
    } else if (t.classList && t.classList.contains('ai1-wl-check')) {
      updateSelState();
    }
  });

  /* register with core */
  A.openDrawer = openDrawer;
  A.onSync = function () {
    var d = document.getElementById('ai1-wl-drawer');
    if (d && d.classList.contains('is-open')) { renderDrawer(); hydrateDrawerVariants(); }
    hydratePage();
  };

  // Hydrate the full wishlist page once, after core has rendered it.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydratePage);
  else hydratePage();
})();
